<template>
  <div class="container">
    <div class="cfm-msg-box">
      <p>{{ message }}</p>
      <p><a class="link-btn" href="/">Go back to Home Page</a></p>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import FacilitatorServices from '@/services/facilitator';
import Logger from '@/utils/logger';

const $route = useRoute();
const $router = useRouter();

const message = ref('Checking account ... ...');

onBeforeMount(async () => {
  if (!$route.params.fid || !$route.params.token) {
    $router.push({ name: 'login' });
    return;
  }

  try {
    const activatedResult = await FacilitatorServices.activateFacilitator($route.params.fid, $route.params.token);

    if (!activatedResult.record) {
      $router.push({ name: 'login' });
      return;
    }

    message.value = 'Your account has been successfully activated.';
  } catch (error) {
    // TODO: maybe a warning page
    Logger.error(error.message);
    message.value = 'Account activation failed';
  }
});
</script>

<script>
export default {
  name: 'ConfirmationPage',
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 1em;
  background: linear-gradient(to bottom, #66cc99, #3399cc);
}

.cfm-msg-box {
  width: 100%;
  color: #fff;
  font-size: 1.4em;
}
.cfm-msg-box p {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  width: 100%;
}
.cfm-msg-box p:first-child {
  height: 3em;
  text-align: center;
}
.cfm-msg-box p:last-child {
  margin-top: 1em;
}

.link-btn {
  display: inline-block;
  border-radius: 0.5em;
  padding: 0.8em 2em;
  background: rgba(255, 255, 255, 0.3);
  color: #fff;
  font-size: 0.8em;
  text-align: center;
  cursor: pointer;
}
</style>
